import React, { Component } from 'react';
import LoaderWrapper from '../../../../Components-2025/QuestionBank/LoaderWrapper';
import ReportCard from '../../../../Components-2025/QuestionBank/ReportCard';
import VideoPlayListView from '../../../../Components-2025/Videos/VideoPlayList';
import VideoValidateReportsIcons from '../../../../Components-2025/Videos/VideoValidateReportsIcons';
import ComponentHeader from '../../../../common/ComponentHeader';
import { messages } from '../../../../common/messages';
import { showInformation } from '../../../../common/toast';
import FlashCard from '../../../../components/FlashCard';
import ModalComponent from '../../../Common/Modal';
import config from '../../../config/AppRoutes';
import { nextAwareRoute } from '../../../../common/cfa1NextRoutes';
import {
  chapterIdKey,
  chapterNameKey,
  videoTableChapterIdKey,
  videoTitleKey,
  youtubeIdKey,
} from './ApiAttributesKays';
import apiServiceProvider from './ApiService';
import {
  aiTutorExamYear,
  aiTutorPageUrl,
  clearAiTutorContext,
  dispatchAiTutorContext,
  dispatchAiTutorExplain,
  AI_TRIGGER_BTN_STYLE,
} from '../../../../common/aiTutorContext';
let videoTableKey = 'cfa1_2025_videos';

/* eslint-disable*/

export default class VideoPlayList extends Component {
  static contextTypes = { router: React.PropTypes.object };
  constructor(props) {
    super(props);
    this.state = {
      videoData: [],
      currentIndex: 0,
      title: '',
      isLoading: true,
      isFlashCardHidden: true,
      isReportSectionShow: false,
      isPremiumPopupOpen: false,
      isUserSubscriptionStatus: false,
    };
    this.childRef = null;
    this.setChildRef = (element) => {
      this.childRef = element;
    };
  }
  async componentDidMount() {
    this.setState({ isLoading: true });
    const { chapterId, id } = this.props.params;
    const { mockId, mediaType } = this.props.location.query;
    await this.getChapterWiseVideos({ chapterId, id, mockId, mediaType });
  }

  componentWillUnmount() {
    // leaving the video view → drop stale AI Tutor context
    clearAiTutorContext();
  }

  getChapterWiseVideos = async (payload) => {
    const result = await apiServiceProvider['fetchVideos'](payload);
    if (result.success) {
      videoTableKey = result.associatedVideosTable;
      const videosData = result.data[0][videoTableKey];
      const { id } = payload;
      const currentIndex = videosData.findIndex((item) => item.id === parseInt(id, 10));
      //* HERE ADDED A CHECK IF USER WANT TO ACCESS PREMIUM VIDEO WITHOUT SUBSCRIPTION */
      const level1Sub =
        result.selectedExamSubscriptionDetails.level1SubscriptionDetails;
      const isUserSubscriptionStatus = level1Sub && level1Sub.videoStatus;
      // Live Sessions ("webinar" media_type) — Unlimited+ (pkg 78) is the only
      // paid tier with full access; other tiers can only play the ones flagged
      // free. `hasCfaPlus` comes from cfaSubscriptionCheckMiddleware which
      // detects pkg 78 straight from subscription_details, so pkg-15+pkg-78
      // co-holders (e.g. user 159915) resolve to true even when the middleware
      // short-circuits into the plain Unlimited details.
      const currentVideo = videosData[currentIndex];
      const hasPlusAccess = !!result.selectedExamSubscriptionDetails.hasCfaPlus;
      const isWebinar = currentVideo && currentVideo.media_type === 'webinar';
      const canPlayCurrent = currentVideo && (
        currentVideo.free ||
        (isWebinar ? hasPlusAccess : isUserSubscriptionStatus)
      );
      if (canPlayCurrent) {
        this.setState({
          isLoading: false,
          currentIndex: currentIndex > -1 ? currentIndex : 0,
          videoData: result.data.length && result.data[0][videoTableKey],
          title: result.data.length && result.data[0][chapterNameKey],
          isUserSubscriptionStatus,
          // Persist the Plus tier flag so navigateToVideoByID can re-check
          // access when jumping between playlist entries without a refetch.
          hasPlusAccess,
        });
        // tell the AI Tutor which lecture the student is viewing (chapter passed explicitly —
        // this.state.title isn't committed yet inside this setState batch)
        this.dispatchAiContext(
          videosData[currentIndex > -1 ? currentIndex : 0],
          result.data.length && result.data[0][chapterNameKey],
        );
      } else {
        const { router } = this.context;
        router.push({ pathname: config.FRM_VIDEOS });
        showInformation(messages.PLEASE_SUBSCRIBE_TO_ACCESS_THIS_VIDEO);
      }
    } else {
      this.setState({ isLoading: false });
    }
  };

  buildAiContext = (video, chapterName) => ({
    exam: 'CFA1',
    exam_year: aiTutorExamYear(), // 2026/2027 from the header's selected exam; null when unknown
    page_url: aiTutorPageUrl(),
    page_type: 'video',
    content_id: video && video.id,
    title: (video && video[videoTitleKey]) || 'CFA Level I',
    // extra retrieval grounding — the KB chunks carry a matching `chapter` metadata field
    chapter: chapterName || this.state.title || '',
    // reading name (resolved server-side from the video's reading_id) — grounding + analytics,
    // matches what Notes sends; empty when the lecture isn't tied to a reading (reading_id 0)
    reading: (video && video.reading_name) || '',
    // the lecture title is the retrieval key — KB video transcripts are titled by lecture name
    stem: (video && video[videoTitleKey]) || '',
  });

  dispatchAiContext = (video, chapterName) => {
    if (!video) return;
    dispatchAiTutorContext(this.buildAiContext(video, chapterName));
  };

  askAiAboutLecture = () => {
    const { videoData, currentIndex } = this.state;
    const video = videoData[currentIndex];
    if (!video) return;
    dispatchAiTutorExplain({
      context: this.buildAiContext(video),
      message: 'Summarize the key ideas of this lecture',
    });
  };

  navigateToVideoByID = async (index) => {
    const { state } = this;
    const { isUserSubscriptionStatus, videoData, hasPlusAccess } = state;
    // Same Live Sessions tier gate as getChapterWiseVideos above.
    // Webinars require Plus tier OR free flag; topic videos fall back to
    // the standard videoStatus check.
    const nextVideo = videoData[index];
    const isWebinar = nextVideo && nextVideo.media_type === 'webinar';
    const canPlayNext = nextVideo && (
      nextVideo.free ||
      (isWebinar ? hasPlusAccess : isUserSubscriptionStatus)
    );
    if (canPlayNext) {
      this.setState({ currentIndex: index });
      this.dispatchAiContext(videoData[index]);
      const { router } = this.context;
      router.push({
        pathname: nextAwareRoute(config.CFA1_VIDEO_LIST).replace(':id', videoData[index].id).replace(
          ':chapterId',
          videoData[index][videoTableChapterIdKey],
        ),
        query: {
          ...(videoData[index].mock_id && { mockId: videoData[index].mock_id }),
          ...(videoData[index].media_type === 'webinar' && { mediaType: 'webinar' }),
        },
      });
      await apiServiceProvider['saveLastViewedVideo']({
        videoId: videoData[index].id,
        videoIndex: index,
      });
    } else {
      this.setState({ isPremiumPopupOpen: true });
    }
  };

  redirectToSubscription = () => {
    const { router } = this.context;
    router.push({ pathname: '/Subscribe' });
  };

  onHandleToggleAlert = () => {
    this.setState({ isPremiumPopupOpen: !this.state.isPremiumPopupOpen });
  };

  onSaveItemChange = (status) => {
    this.setState({ isFlashCardHidden: status });
  };

  toggleReportSection = () =>
    this.setState((prevState) => ({ isReportSectionShow: !prevState.isReportSectionShow }));

  onHandleHideReportSection = () => {
    this.setState({ isReportSectionShow: false });
  };

  render() {
    const { router } = this.context;
    const { state } = this;
    const {
      videoData,
      isLoading,
      currentIndex,
      isUserSubscriptionStatus,
      isPremiumPopupOpen,
      isFlashCardHidden,
      isReportSectionShow,
      title,
    } = state;
    const { mockId } = this.props.location.query;

    return (
      <div className='animated fadeIn'>
        <LoaderWrapper isLoading={isLoading}>
          <div>
            <ComponentHeader className="" title={title}>
              {/* Grouped + wrapping so the row never overflows the viewport on mobile. */}
              <div className='d-flex flex-wrap align-items-center' style={{ gap: 8, marginLeft: 'auto', justifyContent: 'flex-end' }}>
                <button
                  className='btn btn-primary pointer_class'
                  onClick={() => router.push({ pathname: nextAwareRoute(config.CFA1_VIDEOS) })}
                >
                  {messages.BACK_TO_VIDEOS}
                </button>
                <button className='pointer_class ap-ai-launcher' style={AI_TRIGGER_BTN_STYLE} onClick={this.askAiAboutLecture}>
                  ✦ Ask AI about this lecture
                </button>
              </div>
            </ComponentHeader>
            <VideoPlayListView
              videoTitle={videoData[currentIndex] ? videoData[currentIndex][videoTitleKey] : ''}
              currentIndex={currentIndex}
              videosData={videoData}
              youtubeID={videoData[currentIndex] ? videoData[currentIndex][youtubeIdKey] : ''}
              navigateToVideoByID={this.navigateToVideoByID}
              toggleAlert={this.onHandleToggleAlert}
              isUserSubscribed={isUserSubscriptionStatus}
            />
            <br /> <br />
            <VideoValidateReportsIcons
              isMoveToNotesIcon={!mockId}
              isMoveToQuestionIcon={!mockId}
              toggleAlert={this.onHandleToggleAlert}
              savePayLoad={{ videoId: videoData[currentIndex] && videoData[currentIndex].id }}
              favItemId={videoData[currentIndex] && videoData[currentIndex].id}
              notesRedirectRoute={nextAwareRoute(config.CFA1_2025_NOTES_READING_LIST).replace(
                ':chapterId',
                videoData[currentIndex] && videoData[currentIndex][chapterIdKey],
              )}
              questionRedirectRoute={nextAwareRoute(config.CFA1_2025_QUESTION_BANK_READING_LIST).replace(
                ':chapterId',
                videoData[currentIndex] && videoData[currentIndex][chapterIdKey],
              )}
              setChildRef={this.childRef}
              currentVideo={videoData[currentIndex] && videoData[currentIndex]}
              apiServiceProvider={apiServiceProvider}
              onSaveItemChange={this.onSaveItemChange}
              toggleReportSection={this.toggleReportSection}
              isUserSubscribed={isUserSubscriptionStatus}
            />
            <FlashCard
              item={{ id: videoData[currentIndex] ? videoData[currentIndex].id : '' }}
              type='video'
              isFlashCardHidden={isFlashCardHidden}
              ref={this.setChildRef}
              exam='cfa1_2024'
            />
            {isReportSectionShow && (
              <ReportCard
                section='video'
                hideReportSection={this.onHandleHideReportSection}
                apiServiceProvider={apiServiceProvider}
                itemId={videoData[currentIndex] ? videoData[currentIndex].id : ''}
                keyId='videoId'
              />
            )}
          </div>
        </LoaderWrapper>
        <ModalComponent
          goPremium={this.redirectToSubscription}
          toggleAlert={this.onHandleToggleAlert}
          alert_status={isPremiumPopupOpen}
          MessageContent={messages.CFA1_2025_PREMIUM_POPUP}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/CFA1-2025/Videos/PlayList/VideoPlayList.jsx